import { maskPII, trackTelemetryEvent } from './appInsights';
import { getDeviceType } from './chatAnalytics';

const CHAT_SESSION_STORAGE_KEY = 'chat_session_id';

const ensureChatSessionId = () => {
  try {
    let sessionId = sessionStorage.getItem(CHAT_SESSION_STORAGE_KEY);
    if (!sessionId) {
      sessionId = `chat_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 8)}`;
      sessionStorage.setItem(CHAT_SESSION_STORAGE_KEY, sessionId);
    }
    return sessionId;
  } catch (error) {
    return `chat_${Date.now().toString(36)}`;
  }
};

const withCommonProps = (properties = {}) => {
  const sessionId = ensureChatSessionId();
  const baseProps = {
    sessionId,
    page_path: typeof window !== 'undefined' ? window.location.pathname : 'unknown',
    device_type: typeof window !== 'undefined' ? getDeviceType() : 'unknown',
    timestamp: new Date().toISOString()
  };

  return maskPII({
    ...baseProps,
    ...properties
  });
};

export const trackChatEvent = (eventName, properties) => {
  trackTelemetryEvent(eventName, withCommonProps(properties));
};

export const getChatSessionId = ensureChatSessionId;
